import { FORM_KEYS } from 'shared/constant';
import { ACTION_TYPE } from '../actions/actionTypes';

const { PERSONAL_INFORMATION } = ACTION_TYPE;
const {
  PEP, CLIENT_DETAILS, CLIENT_PROFILE_FORM, ASI,
} = FORM_KEYS;

const personalInformationReducer = (state = {}, action) => {
  switch (action.type) {
    case PERSONAL_INFORMATION.FETCH_PERSONAL_INFORMATION:
      return {
        ...state,
        clientDetails: action.payload.clientDetails,
        pep: action.payload.pep,
        bankDetails: action.payload.bankDetails,
        sourceOfWealth: action.payload.sourceOfWealth,
        asi: action.payload.asi,
        clientProfileForm: action.payload.clientProfileForm,
      };

    /** CLIENT DETAILS */
    case PERSONAL_INFORMATION.UPDATE_CLIENT_DATA:
      const newClientData = { ...state.clientDetails };
      newClientData[action.payload.name] = action.payload.value;
      return { ...state, clientDetails: newClientData };
    case PERSONAL_INFORMATION.CD_QUALIFIED_INVESTOR_OPTIONS:
      return { ...state, clientDetails: { ...state.clientDetails, [CLIENT_DETAILS.QUALIFIED_INVESTOR]: action.payload } };
    case PERSONAL_INFORMATION.CD_INVESTMENT_STRATEGIES:
      return { ...state, clientDetails: { ...state.clientDetails, [CLIENT_DETAILS.INVESTMENT_STRATEGY]: action.payload } };

      /** PEP */
    case PERSONAL_INFORMATION.IS_PEP:
      return { ...state, pep: { ...state.pep, [PEP.IS_PEP]: action.payload } };
    case PERSONAL_INFORMATION.PEP_BENEFICIARIES:
      return { ...state, pep: { ...state.pep, [PEP.BENEFICIARIES]: action.payload } };

    /** BANK DETAILS */
    case PERSONAL_INFORMATION.UPDATE_BANK_DETAILS:
      const newBankData = { ...state.bankDetails };
      newBankData[action.payload.name] = action.payload.value;
      return { ...state, bankDetails: newBankData };
    case PERSONAL_INFORMATION.UPDATE_CARD_INFO:
      return {
        ...state,
        bankDetails: {
          ...state.bankDetails,
          cardInfo: action.payload,
        },
      };

    /** SOURCE OF WEALTH & FUNDS */
    case PERSONAL_INFORMATION.UPDATE_SOURCE_OF_WEALTH:
      const newData = { ...state.sourceOfWealth };
      newData[action.payload.name] = action.payload.value;
      return { ...state, sourceOfWealth: newData };

    /** AUTHORIZED SIGNATORY INFORMATION */
    case PERSONAL_INFORMATION.UPDATE_ASI:
      const newAsiData = { ...state.asi };
      newAsiData[action.payload.name] = action.payload.value;
      return { ...state, asi: newAsiData };
    case PERSONAL_INFORMATION.SAVE_ASI_POA:
      return { ...state, asi: { ...state.asi, [ASI.POA_HOLDER]: action.payload } };

    /** CLIENT PROFILE FORM */
    case PERSONAL_INFORMATION.UPDATE_CLIENT_PROFILE:
      const newCPFData = { ...state.clientProfileForm };
      newCPFData[action.payload.name] = action.payload.value;
      return { ...state, clientProfileForm: newCPFData };

    case PERSONAL_INFORMATION.HAVE_INVESTMENT_EXP:
      return { ...state, withInvestmentExp: action.payload };

    case PERSONAL_INFORMATION.AUTO_UPDATE_CLIENT_PROFILE_INVESTMENT_EXP:
      return {
        ...state,
        clientProfileForm: {
          ...state.clientProfileForm,
          ieBondsYrs: 'NW-MAR-IEY-NONE',
          ieEquitiesYrs: 'NW-MAR-IEY-NONE',
          iePrivateEquityHedgeFundsYrs: 'NW-MAR-IEY-NONE',
          ieRealEstateYrs: 'NW-MAR-IEY-NONE',
          ieOtherAlternativeInvestmentsYrs: 'NW-MAR-IEY-NONE',
        },
      };

    case PERSONAL_INFORMATION.UPDATE_INSIDER_STATUS_LIST:
      return { ...state, clientProfileForm: { ...state.clientProfileForm, [CLIENT_PROFILE_FORM.INSIDER_STATUS_LIST]: action.payload } };

    case PERSONAL_INFORMATION.UPDATE_CLIENT_PROFILE_ASSET_CLASSES:
      return { ...state, clientProfileForm: { ...state.clientProfileForm, [CLIENT_PROFILE_FORM.ASSET_CLASSES]: action.payload } };

    case PERSONAL_INFORMATION.UPDATE_CLIENT_PROFILE_MARKETS:
      return { ...state, clientProfileForm: { ...state.clientProfileForm, [CLIENT_PROFILE_FORM.MARKETS]: action.payload } };

    default:
      return state;
  }
};

export default personalInformationReducer;
